import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrustSection from "./components/TrustSection";
import AboutSection from "./components/AboutSection";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonSection from "./components/ComparisonSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://acbuy.wiki";

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                name: "ACBuy Wiki",
                url: siteUrl,
                description:
                  "ACBuy Spreadsheet is the most advanced product comparison and tracking system for smarter online shopping. Compare prices, track products, and discover the best deals with our updated acbuy spreadsheet database in 2026.",
                potentialAction: {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://kaspreadsheet.com/search?q={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              },
              {
                "@type": "Organization",
                name: "ACBuy Wiki",
                url: siteUrl,
                logo: {
                  "@type": "ImageObject",
                  url: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/acdcfd47829ab306d380ea84eb14e50b.jpeg",
                },
                sameAs: ["https://kaspreadsheet.com"],
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustSection />
        <AboutSection />
        <CategoryGrid />
        <ComparisonSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <FooterSection />
    </>
  );
}